import Modal from "@Generic/modal/Modal";
import React from "react";
import {useTranslation} from "@Translation/hooks/useTranslation";

function UnexpectedError() {
    const handleClose = () => {
        window.location.reload()
    }

    const {
        there_has_been_an_error: errorNotice,
    } = useTranslation("check_order")
    return (
        <Modal
            message="An unexpected error occurred"
            buttonText="OK"
            title={errorNotice}
            handleClick={handleClose}
            isInnerHtml
        />
    )
}

export default UnexpectedError